<script setup>
import MadeInGermanyIcon from '@/components/icons/MadeInGermanyIcon.vue';
import Tooltip from '~/components/common/Tooltip.vue';
import CldnImg from '@/components/CldnImg';

const props = defineProps({
  image: Object,
  imageMetadata: Array,
  index: Number,
  product: Object,
  activeSlideIndex: Number,
});

const tooltipContents = computed(() => {
  return props.imageMetadata?.find((item) => `gid://shopify/ProductImage/${item.id}` === props.image.id) || null;
});

const lightGalleryInstance = inject('lightGalleryInstance');

const openGallery = () => {
  if (lightGalleryInstance.value) {
    lightGalleryInstance.value.openGallery(props.index);
  }
};
</script>

<template>
  <div class="swiper-slide" @click="openGallery">
    <CldnImg class="w-full" :src="image.src" :alt="image.alt" sizes="100vw md:50vw lg:50vw xl:50vw 2xl:50vw" />
    <div class="absolute inset-x-0 bottom-0">
      <MadeInGermanyIcon
        v-if="product.isMadeInGermany && index === 0"
        class="relative z-10 bottom-2 left-2 md:bottom-4 md:left-4"
      />
    </div>
    <Tooltip v-show="tooltipContents" :contents="tooltipContents" />
  </div>
</template>
